// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====== Base Navbar Styles ====== */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #00703C; /* Green from logo */
  color: white;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
}

/* ✅ Shrink when scrolling */
.navbar.scrolled {
  padding: 0.6rem 1.5rem;
  background-color: #006633; /* Slightly darker green on scroll */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

/* ====== Logo ====== */
.navbar-logo {
  display: flex;
  align-items: center;
}

.navbar-logo img {
  height: 65px;
  width: auto;
  border-radius: 50%;
  background-color: white;
  padding: 4px;
  transition: all 0.3s ease-in-out;
}

/* ✅ Shrink logo smoothly when scrolled */
.navbar.scrolled .navbar-logo img {
  height: 55px;
}

/* ====== Nav Links ====== */
.navbar-links ul {
  display: flex;
  list-style: none;
  gap: 1.2rem;
  margin: 0;
  padding: 0;
  align-items: center;
}

.navbar-links a {
  text-decoration: none;
  color: white;
  font-weight: 500;
  transition: color 0.3s;
}

.navbar-links a:hover {
  color: #E22B2B; /* Red accent */
}

/* ====== Login Button ====== */
.login-btn {
  background-color: white;
  color: #00703C;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
}

.login-btn:hover {
  background-color: #E22B2B;
  color: white;
  transform: translateY(-2px);
}

/* ====== Hamburger ====== */
.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  width: 25px;
  height: 18px;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.hamburger span {
  background-color: white;
  height: 3px;
  border-radius: 2px;
  transition: all 0.3s;
}

/* ====== Mobile ====== */
@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .navbar-links {
    position: absolute;
    top: 70px;
    left: 0;
    background-color: #00703C;
    width: 100%;
    text-align: center;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  }

  .navbar-links.open {
    max-height: 450px;
  }

  .navbar-links ul {
    flex-direction: column;
    gap: 1rem;
    padding: 1.2rem 0;
  }

  /* ✅ Login button in mobile menu */
  .login-btn {
    background-color: #ffffff;
    color: #00703C;
    width: 60%;
    margin: 0.5rem auto;
    display: block;
  }

  .login-btn:hover {
    background-color: #E22B2B;
    color: white;
  }

  /* Hamburger animation */
  .hamburger.active span:nth-child(1) {
    transform: rotate(45deg) translate(4px, 4px);
  }

  .hamburger.active span:nth-child(2) {
    opacity: 0;
  }

  .hamburger.active span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }
}
/* Member nav link — highlighted so it stands out */
.nav-member-link {
  color: #FFD700 !important;
  font-weight: bold;
}

.nav-member-link:hover {
  color: #fff !important;
}
/* Add this to the bottom of your Navbar.css */

.nav-leader-link {
  color: #fbbf24 !important;   /* amber — stands out from regular nav links */
  font-weight: 700 !important;
}

.nav-leader-link:hover {
  color: #f59e0b !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,yBAAyB,EAAE,oCAAoC;EAC/D,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,uCAAuC;IACvC,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8CAA8C;EAChD;AACF;AACA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA,8CAA8C;;AAE9C;EACE,yBAAyB,IAAI,8CAA8C;EAC3E,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ====== Base Navbar Styles ====== */\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #00703C; /* Green from logo */\n  color: white;\n  padding: 1rem 1.5rem;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease-in-out;\n}\n\n/* ✅ Shrink when scrolling */\n.navbar.scrolled {\n  padding: 0.6rem 1.5rem;\n  background-color: #006633; /* Slightly darker green on scroll */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n}\n\n/* ====== Logo ====== */\n.navbar-logo {\n  display: flex;\n  align-items: center;\n}\n\n.navbar-logo img {\n  height: 65px;\n  width: auto;\n  border-radius: 50%;\n  background-color: white;\n  padding: 4px;\n  transition: all 0.3s ease-in-out;\n}\n\n/* ✅ Shrink logo smoothly when scrolled */\n.navbar.scrolled .navbar-logo img {\n  height: 55px;\n}\n\n/* ====== Nav Links ====== */\n.navbar-links ul {\n  display: flex;\n  list-style: none;\n  gap: 1.2rem;\n  margin: 0;\n  padding: 0;\n  align-items: center;\n}\n\n.navbar-links a {\n  text-decoration: none;\n  color: white;\n  font-weight: 500;\n  transition: color 0.3s;\n}\n\n.navbar-links a:hover {\n  color: #E22B2B; /* Red accent */\n}\n\n/* ====== Login Button ====== */\n.login-btn {\n  background-color: white;\n  color: #00703C;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 25px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.login-btn:hover {\n  background-color: #E22B2B;\n  color: white;\n  transform: translateY(-2px);\n}\n\n/* ====== Hamburger ====== */\n.hamburger {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  width: 25px;\n  height: 18px;\n  justify-content: space-between;\n  transition: all 0.3s ease;\n}\n\n.hamburger span {\n  background-color: white;\n  height: 3px;\n  border-radius: 2px;\n  transition: all 0.3s;\n}\n\n/* ====== Mobile ====== */\n@media (max-width: 768px) {\n  .hamburger {\n    display: flex;\n  }\n\n  .navbar-links {\n    position: absolute;\n    top: 70px;\n    left: 0;\n    background-color: #00703C;\n    width: 100%;\n    text-align: center;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n  }\n\n  .navbar-links.open {\n    max-height: 450px;\n  }\n\n  .navbar-links ul {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1.2rem 0;\n  }\n\n  /* ✅ Login button in mobile menu */\n  .login-btn {\n    background-color: #ffffff;\n    color: #00703C;\n    width: 60%;\n    margin: 0.5rem auto;\n    display: block;\n  }\n\n  .login-btn:hover {\n    background-color: #E22B2B;\n    color: white;\n  }\n\n  /* Hamburger animation */\n  .hamburger.active span:nth-child(1) {\n    transform: rotate(45deg) translate(4px, 4px);\n  }\n\n  .hamburger.active span:nth-child(2) {\n    opacity: 0;\n  }\n\n  .hamburger.active span:nth-child(3) {\n    transform: rotate(-45deg) translate(5px, -5px);\n  }\n}\n/* Member nav link — highlighted so it stands out */\n.nav-member-link {\n  color: #FFD700 !important;\n  font-weight: bold;\n}\n\n.nav-member-link:hover {\n  color: #fff !important;\n}\n/* Add this to the bottom of your Navbar.css */\n\n.nav-leader-link {\n  color: #fbbf24 !important;   /* amber — stands out from regular nav links */\n  font-weight: 700 !important;\n}\n\n.nav-leader-link:hover {\n  color: #f59e0b !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
